import { useTranslation } from 'react-i18next'
import { DurationIcon, LightbulbIcon } from '@/src/renderer/components/icons'
import { formatFocusAgainstEstimate, isOverEstimate } from '@/src/renderer/lib/focus'
import { formatDuration } from '../../utils/parseDuration'
import './TaskDurationBadge.scss'
import type { TaskDurationBadgeProps } from './TaskDurationBadge.types'

/**
 * Die **Dauer-Marke** an der Aufgabenzeile — Uhr-Zeichen und die veranschlagte
 * Dauer, „10m".
 *
 * **Mit gebuchter Fokuszeit steht davor, was verbraucht ist**: „9s von 10m"
 * (Nutzer-Vorgabe, 2026-09-18). Hier und nicht als zweite Angabe daneben — die
 * Marke trägt die Dauer ohnehin, und erst zusammen sagen die Zahlen etwas.
 * Beide Seiten in derselben kurzen Schreibweise, sonst läsen sich zwei Sprachen
 * in einer Pille.
 *
 * Über der Dauer färbt sich die Marke um und sagt sonst nichts — dieselbe
 * stille Regel wie der Zeit-Chip des Fokus-Fensters (CONTEXT.md, Überzeit).
 */
export function TaskDurationBadge({ minutes, mode, focusedSeconds }: TaskDurationBadgeProps) {
  const { t } = useTranslation()
  const fokussiert = typeof focusedSeconds === 'number' && focusedSeconds > 0

  return (
    <span
      className="task-duration-badge"
      data-over={fokussiert && isOverEstimate(focusedSeconds!, minutes) ? '' : undefined}
    >
      {mode === 'thinking' ? <LightbulbIcon size={16} /> : <DurationIcon size={16} />}
      <span className="task-duration-badge__text">
        {fokussiert
          ? formatFocusAgainstEstimate(focusedSeconds!, minutes, t)
          : formatDuration(minutes, mode, t('taskCreation.durationDayUnit'))}
      </span>
    </span>
  )
}
